"use client";

import { Input } from "@headlessui/react";
import { debounce } from "lodash";
import { useEffect, useRef, useState } from "react";
import Pagination from "./Pagination";
import { fetchAllPatientenDetails } from "../apiCalls/usersApi";

const SelectPatientPagination = ({ setData, setLoading, setError, placeholder = "Zoeken patient op" }) => {
  const [search, setSearch] = useState(() => localStorage.getItem("QUERY") || ""); // ✅ initialize from storage
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(4);
  const debouncedFetchRef = useRef();

  // Debounced fetch when page/pageSize change
  useEffect(() => {
    debouncedFetchRef.current = debounce((query) => {
      fetchAllPatientenDetails(
        pageSize,
        page,
        query,
        setLoading,
        setError,
        setData
      );
    }, 300);

    return () => {
      debouncedFetchRef.current?.cancel();
    };
  }, [pageSize, page, setLoading, setError, setData]);

  // Debounced search
  useEffect(() => {
    localStorage.setItem("QUERY", search); // ✅ store the query
    if (debouncedFetchRef.current) {
      debouncedFetchRef.current(search);
    }
  }, [search]);

  // Immediate fetch on page/pageSize change
  useEffect(() => {
    fetchAllPatientenDetails(pageSize, page, search, setLoading, setError, setData);
  }, [page, pageSize]);

  return (
    <div className="flex w-full items-center gap-3 rounded-md">
      <Input
        placeholder={placeholder}
        className="block w-full rounded-md border border-wa-border bg-wa-panel2 py-2 pl-3 pr-3 text-sm text-wa-text outline-none placeholder:text-wa-muted focus:border-wa-accent focus:ring-1 focus:ring-wa-accent"
        value={search}
        onChange={(event) => setSearch(event.target.value)}
      />

      <Pagination
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        pageRanges={[4, 8, 16, 32, 64, 128]}
        variant="compact"
      />
    </div>
  );
};

export default SelectPatientPagination;
